// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1Zxfw","radioRow":"SimpleQuestionBuilderModal_radioRow__1itg2"};